import { c as _c } from "react/compiler-runtime";
import { Card } from "../ui/card";
import { AspectRatio } from "../ui/aspect-ratio";
import Image from "next/image";
type NonCertificationBannerCardProps = {
  certificationImage: string | null;
};
const NonCertificationBannerCard = t0 => {
  const $ = _c(4);
  const {
    certificationImage
  } = t0;
  let t1;
  if ($[0] !== certificationImage) {
    t1 = certificationImage && <Image src={certificationImage} alt="non-certificaion-image" fill={true} className="object-contain" sizes="305px" />;
    $[0] = certificationImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Card className="sticky top-20 z-0 py-0 shadow-md"><AspectRatio ratio={1.4144271570014144} className="h-full w-full">{t1}</AspectRatio></Card>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default NonCertificationBannerCard;